import axios from 'axios'
import {
  errorInterceptor,
  requestInterceptor,
  responseInterceptor,
} from './interceptors'
import { isMyEasybellCom } from '@/utils/environment'

function getBaseUrlForApi() {
  const apiUrl = '/api/'
  return apiUrl
}

const http = axios.create({
  baseURL: getBaseUrlForApi(),
  headers: {
    'Cache-Control': 'no-cache',
    'X-Environment': isMyEasybellCom() ? 'my.easybell.com' : 'easybell.de',
  },
})

http.interceptors.request.use(requestInterceptor)

http.interceptors.response.use(responseInterceptor, errorInterceptor)

export { http, getBaseUrlForApi }
